<script setup lang="ts">
type Props = {
  active?: boolean
  fullWidth?: boolean
  class?: string
  as?: string
}

const props = defineProps<Props>()

const classes = computed(() => ({
  'app-button-select': true,
  'app-button-select--active': props.active,
  'app-button-select--full-width': props.fullWidth,
  [`${props.class}`]: !!props.class,
}))

const componentType = computed(() => props.as || 'button')
</script>

<template>
  <component :is="componentType" :class="classes">
    <span class="app-button-select__icon"><slot name="icon"></slot></span>

    <span class="app-button-select__content truncate"><slot></slot></span>

    <IconChevronDown />
  </component>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-button-select {
  display: inline-flex;
  align-items: center;
  padding-right: 0.75rem;
  font-family: $font-barlow;
  font-size: 1rem;
  line-height: 1.25;
  color: $black;
  background-color: $gray-100;
  border: 1px solid $black;
  border-radius: 0.125rem;
  @include transition('background-color');

  svg {
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
  }

  .IconChevronDown {
    margin-left: auto;
    @include transition('transform');
  }

  &:hover {
    background-color: $gray-200;
  }

  &:focus {
    outline: none;
    background-color: $white;
  }
}

.app-button-select__icon {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3.25rem;
  height: 3.25rem;
  margin-right: 0.75rem;
  background-color: $white;
  border-right: 1px solid $black;

  @include media-breakpoint-up(md) {
    width: 3.75rem;
    height: 3.75rem;
  }
}

.app-button-select__content {
  margin-right: 0.75rem;
}

.app-button-select--active {
  .IconChevronDown {
    transform: scaleY(-1);
  }
}

.app-button-select--full-width {
  display: flex;
  width: 100%;
}
</style>
